module.exports = __webpack_public_path__ + "img/shopping_cart_out@4x.afa9ff4f.png";